import { EditorNames } from './EditorNames';
import { EditorAssignees } from './EditorAssignees/EditorAssignees';
import { EditorCheckbox } from './EditorCheckbox';
import { EditorCombo } from './EditorCombo';
import { DisplayStringEditor } from './DisplayStringEditor';
import { ReadOnlyEditor } from './ReadOnlyEditor';
import { EditorStringArrayField } from './EditorStringArrayField';
import { EditorTextArea } from './EditorTextArea';
import { EditorTextField } from './EditorTextField';
import { SuggestStringEditor } from './SuggestStringEditor';
import { EditorMergeString } from './EditorMergeString';
import { ArrayEditor } from './ArrayEditor';
import { DataDefinitionsEditor } from './DataDefinitionsEditor';
import { IEditorProps } from './Editor';
import { ColorEditor } from 'components/Editors/ColorEditor';
import { EditorEntityPicker } from './entity-picker/EditorEntityPicker';
import { SelectElementRegistrationEditor } from './entity-picker/SelectElementRegistrationEditor';
import { ApprovalChainEditor } from './ApprovalChainEditor';
import { NumericArrayEditor } from './NumericArrayEditor';
import { CharArrayEditor } from './CharArrayEditor';
import { PasswordEditor } from './PasswordEditor';
import { RadioListEditor } from './RadioListEditor';
import { CheckListEditor } from './CheckListEditor';
import { TimeSpanEditor } from './TimeSpanEditor/TimeSpanEditor';
import { NullableCheckboxEditor } from './NullableCheckboxEditor';
import { NumberFormatEditor } from './NumberFormatEditor/NumberFormatEditor';
import { GroupsPickerEditor } from './GroupsPickerEditor';
import { AccountsPickerEditor } from './AccountsPicker';
import { ShortcutEditor } from './ShortcutEditor/ShortcutEditor';
import { FolderPickerEditor } from './entity-picker/FolderPickerEditor';
import { TableTemplateEditor } from './TableTemplateEditor';
import { UpdateRuleDataTriggerEditor } from './UpdateRuleDataTriggerEditor';
import { DataDescriptionPathEditor } from './DataDescriptionPathEditor/DataDescriptionPathEditor';
import { GridPopupEditor } from './GridPopupEditor';
import { ActiveDirectoryPickerEditor } from './ActiveDirectoryPickerEditor';
import { ImageInfoEditor } from './ImageInfoEditor/ImageInfoEditor';
import { ChartSourcePickerEditor } from './entity-picker/ChartSourcePickerEditor';
import { ChartPartPickerEditor } from './ChartPartPickerEditor';
import { FormDataPickerEditor } from './FormDataPickerEditor';
import { PropertyGridEmbeddedEditor } from 'components/Editors/PropertyGridEmbeddedEditor';
import { EditorDefinedType } from './EditorDefinedType';
import { DigitsEditor } from './DigitsEditor';
import { ThicknessEditor } from './ThicknessEditor';
import { GroupedListEditor } from './GroupedStringEditor';
import { TagFilterEditor } from './TagFilterEditor';
import { CalendarEditor } from './date-time/CalendarEditor';
import { DatePickerEditor } from './date-time/DatePickerEditor';
import { DateTimePickerEditor } from './date-time/DateTimePickerEditor';
import { TimePickerEditor } from './date-time/TimePickerEditor';
import { ChartSeriesEditor } from './ChartSeries/ChartSeriesEditor';
import { TextMergeFieldSelectorEditor } from './legacy-editors/TextMergeFieldSelectorEditor';
import { FileContentPickerEditor } from './FileContentPickerEditor';
import { FormTriggerDataEditor } from './FormTriggerDataEditor/FormTriggerDataEditor';
import { DateTimeArrayEditor } from './date-time/DateTimeArrayEditor';
import { ReportDateRangeEditor } from './ReportDateRangeEditor';
import { ChartTypePickerEditor } from './ChartTypePickerEditor';
import { ChartEntryFilterEditor } from './ChartEntryFilterEditor';
import { NumericRangeFilterEditor } from './data-filters/NumericRangeFilterEditor';
import { StringMatchFilterEditor } from './data-filters/StringMatchFilterEditor';
import { PickStringFilterEditor } from './data-filters/PickStringFilterEditor';
import { CountDataFilterEditor } from './data-filters/CountDataFilterEditor';
import { BooleanDataFilterEditor } from './data-filters/BooleanDataFilterEditor';
import { FilterDateRangeEditor } from './data-filters/FilterDateRangeEditor';
import { TextFieldEditorWithPrefix } from './TextFieldEditorWithPrefix';
import { ColorPaletteEditor } from './ColorPaletteEditor';
import { DataDesignerEditor } from './DataDesignerEditor';
import { OutcomeScenariosEditor } from './OutcomeScenariosEditor';
import { FilePickerEditor } from './FilePickerEditor';
import { MultiFilePickerEditor } from './MultiFilePickerEditor';
import { LayoutEntityEditor } from './LayoutEntityEditor';
import { TypePickerEditor } from './TypePickerEditor';
import { ReportFieldSelectorEditor } from './ReportFieldSelectorEditor';
import { NumericFieldFilterEditor } from './data-filters/NumericFieldFilterEditor';
import { NumericFieldsFilterEditor } from './data-filters/NumericFieldsFilterEditor';
import { SelectByIconEditor } from './SelectByIconEditor/SelectByIconEditor';
import { RangeSliderEditor } from './RangeSliderEditor';

interface IEditorMap {
  [key: string]: React.FunctionComponent<IEditorProps> | React.ComponentClass<IEditorProps>;
}

/*
TODO - this his getting really big... could/should consider something that does some code-splitting here.
Maybe we only pre-load all the most common editors.
*/

export const EditorMap: IEditorMap = {};

EditorMap[EditorNames.String] = EditorTextField;
EditorMap[EditorNames.StringEditor] = EditorTextField;
EditorMap[EditorNames.Digits] = DigitsEditor;
EditorMap[EditorNames.Array] = ArrayEditor;
EditorMap[EditorNames.LinkArrayEditor] = ArrayEditor;
EditorMap[EditorNames.EntityPicker] = EditorEntityPicker;
EditorMap[EditorNames.SelectElementRegistrationEditor] = SelectElementRegistrationEditor;
EditorMap[EditorNames.DataDefinitionsEditor] = DataDefinitionsEditor;
EditorMap[EditorNames.Combo] = EditorCombo;
EditorMap[EditorNames.EditableDropDown] = EditorCombo; // actually different?
EditorMap[EditorNames.TokenPicker] = EditorCombo;
EditorMap[EditorNames.StringFormat] = EditorCombo;
EditorMap[EditorNames.CheckBox] = EditorCheckbox;
EditorMap[EditorNames.NullableCheckBox] = NullableCheckboxEditor;
EditorMap[EditorNames.Readonly] = ReadOnlyEditor;
EditorMap[EditorNames.DisplayString] = DisplayStringEditor;
EditorMap[EditorNames.GridPopup] = GridPopupEditor;
EditorMap[EditorNames.TextArea] = EditorTextArea;
EditorMap[EditorNames.StringArray] = EditorStringArrayField;
EditorMap[EditorNames.NumericArray] = NumericArrayEditor;
EditorMap[EditorNames.Assignees] = EditorAssignees;
EditorMap[EditorNames.SuggestStringEditor] = SuggestStringEditor;
EditorMap[EditorNames.MergeTextEditor] = EditorMergeString;
EditorMap[EditorNames.RowLinkTextEditor] = EditorMergeString;
EditorMap[EditorNames.ReportMergeTextEditor] = EditorMergeString;
EditorMap[EditorNames.ColorEditor] = ColorEditor;
EditorMap[EditorNames.ApprovalLevelsEditor] = ApprovalChainEditor;
EditorMap[EditorNames.CharArrayEditor] = CharArrayEditor;
EditorMap[EditorNames.PasswordEditor] = PasswordEditor;
EditorMap[EditorNames.RadioList] = RadioListEditor;
EditorMap[EditorNames.CheckList] = CheckListEditor;
EditorMap[EditorNames.NumberFormat] = NumberFormatEditor;
EditorMap[EditorNames.Shortcut] = ShortcutEditor;
EditorMap[EditorNames.SelectTagsEditor] = EditorCombo;
EditorMap[EditorNames.FolderPickerEditor] = FolderPickerEditor;
EditorMap[EditorNames.GroupsPicker] = GroupsPickerEditor;
EditorMap[EditorNames.AccountsPicker] = AccountsPickerEditor;
EditorMap[EditorNames.TableTemplateEditor] = TableTemplateEditor;
EditorMap[EditorNames.TimeSpan] = TimeSpanEditor;
EditorMap[EditorNames.UpdateRuleDataTriggerEditor] = UpdateRuleDataTriggerEditor;
EditorMap[EditorNames.ImageInfo] = ImageInfoEditor;
EditorMap[EditorNames.DataDescriptionPathEditor] = DataDescriptionPathEditor;
EditorMap[EditorNames.ActiveDirectoryPickerEditor] = ActiveDirectoryPickerEditor;
EditorMap[EditorNames.ChartSourcePickerEditor] = ChartSourcePickerEditor;
EditorMap[EditorNames.ChartPartPicker] = ChartPartPickerEditor;
EditorMap[EditorNames.FormDataPickerEditor] = FormDataPickerEditor;
EditorMap[EditorNames.EmbeddedPropertyGrid] = PropertyGridEmbeddedEditor;
EditorMap[EditorNames.DefinedTypeEditor] = EditorDefinedType;
EditorMap[EditorNames.GroupedListEditor] = GroupedListEditor;
EditorMap[EditorNames.TagFilterEditor] = TagFilterEditor;
EditorMap[EditorNames.CalendarEditor] = CalendarEditor;
EditorMap[EditorNames.DatePicker] = DatePickerEditor;
EditorMap[EditorNames.DateAndTimePicker] = DateTimePickerEditor;
EditorMap[EditorNames.TimePicker] = TimePickerEditor;
EditorMap[EditorNames.ChartSeriesEditor] = ChartSeriesEditor;
EditorMap[EditorNames.FormTriggerData] = FormTriggerDataEditor;
EditorMap[EditorNames.TextMergeFieldSelector] = TextMergeFieldSelectorEditor;
EditorMap[EditorNames.FileContentPicker] = FileContentPickerEditor;
EditorMap[EditorNames.Thickness] = ThicknessEditor;
EditorMap[EditorNames.DateTimeArray] = DateTimeArrayEditor;
EditorMap[EditorNames.ChartTypePicker] = ChartTypePickerEditor;
EditorMap[EditorNames.ChartEntryFilter] = ChartEntryFilterEditor;
EditorMap[EditorNames.NumericRangeFilter] = NumericRangeFilterEditor;
EditorMap[EditorNames.PickStringFilter] = PickStringFilterEditor;
EditorMap[EditorNames.CountDataFilter] = CountDataFilterEditor;
EditorMap[EditorNames.StringMatchFilter] = StringMatchFilterEditor;
EditorMap[EditorNames.ReportDateRange] = ReportDateRangeEditor;
EditorMap[EditorNames.FilterDateRange] = FilterDateRangeEditor;
EditorMap[EditorNames.BoolDataFilter] = BooleanDataFilterEditor;
EditorMap[EditorNames.StringWithPrefix] = TextFieldEditorWithPrefix;
EditorMap['ColorPaletteEditor'] = ColorPaletteEditor;
EditorMap[EditorNames.DataDesignerEditor] = DataDesignerEditor;
EditorMap[EditorNames.OutcomeScenariosEditor] = OutcomeScenariosEditor;
EditorMap[EditorNames.FilePickerEditor] = FilePickerEditor;
EditorMap[EditorNames.MultiFilePickerEditor] = MultiFilePickerEditor;
EditorMap[EditorNames.LayoutEntityEditor] = LayoutEntityEditor;
EditorMap[EditorNames.TypePickerEditor] = TypePickerEditor;
EditorMap[EditorNames.ReportFieldSelectorEditor] = ReportFieldSelectorEditor;
EditorMap[EditorNames.NumericFieldFilterEditor] = NumericFieldFilterEditor;
EditorMap[EditorNames.NumericFieldsFilterEditor] = NumericFieldsFilterEditor;
EditorMap[EditorNames.SelectByIcon] = SelectByIconEditor;
EditorMap[EditorNames.RangeSliderEditor] = RangeSliderEditor;
